/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';
import { controls } from '../../../../../../../../redux/reducers/common/eventReducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import useMouseEvents from '../../../../../../../../hooks/useMouseEvents';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';

const WallModel = () => {    
    const { gl } = useThree ();

    const cbFrontBackWallOffset = 0.16;
    const wallThickness = 0.005;
    const railWidth = 0.2;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    let offset;

    if(params.leanF_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const wallPosOffset = useMemo(() => {
        if(params.frontLeanStoragePosition > 0 && params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) - railWidth) return railWidth;
        else return 0;
    }, [params.frontLeanStoragePosition, params.leanF_p_d, params.add_storage_front])

    // Side Wall - CSG
    const sideWallModelObj = useMemo(() => {

        let lengthOffset;
        if(params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) - railWidth) lengthOffset = 0.12;
        else lengthOffset = 0;

        let outerModel;
        let innerModel;
        let wainscotModel;

        //variable section
            
        const verticalHorizontalPosS = {"x": params.leanF_p_d / -2,"y" : ((params.p_w_c_n && (params.p_b_c_b_f_l === 'Close' || params.add_storage_front)) ? 2.935 : 0), "z" : params.p_d / 2 + params.leanF_p_w + wallThickness + 0.16}
        const verticalHorizontalRotS = {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
        const patternLengthS = params.leanF_p_h + (params.p_r_s === 1 && 0.15) - 0.1 + ((params.p_w_c_n && (params.p_b_c_b_f_l === 'Close' || params.add_storage_front)) ? -2.935 : 0)
        const patternDepthS = params.leanF_p_d

        const lengthPatternS = 3
        const depthPatternS = patternDepthS

        //************************* */ inner wall geometry
        const sideWallModel = new THREE.Shape();
        sideWallModel.moveTo(-params.leanF_p_d / 2, 0);
        sideWallModel.lineTo(-params.leanF_p_d / 2, params.leanF_p_h + (params.p_r_s === 1 && 0.1));
        sideWallModel.lineTo((-params.leanF_p_d / 2 + parseInt(params.add_storage_front) + lengthOffset + offset + wallPosOffset), params.leanF_p_h + (params.p_r_s === 1 && 0.1));
        sideWallModel.lineTo((-params.leanF_p_d / 2 + parseInt(params.add_storage_front) + lengthOffset + offset + wallPosOffset), 0);
        sideWallModel.closePath();
        
        const meshSideWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(sideWallModel, extrudeSettings(0.005)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        let meshSideWallModel_Temp = meshSideWallModel.clone();
        meshSideWallModel_Temp.position.set(0, 0, params.p_d / 2 + params.leanF_p_w + cbFrontBackWallOffset - 0.02)
        meshSideWallModel_Temp.updateMatrixWorld();
    
        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanF_p_pos - params.frontLeanStoragePosition, 0, params.p_d / 2 + params.leanF_p_w + cbFrontBackWallOffset - 0.5);
        meshSideDelModel_Temp.updateMatrixWorld();
    
        const meshSideWallModel_CSG = CSG.fromMesh(meshSideWallModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
    
        const sideWallModel_CSG =  meshSideWallModel_CSG.subtract(meshSideDelModel_CSG);
        const CSGSideWallModel = CSG.toMesh(
            sideWallModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        innerModel = CSGSideWallModel.geometry;

        //************************* */ outer wall geometry
        const sideWallCutModel = new THREE.Shape();
        sideWallCutModel.moveTo(-(params.leanF_p_d / 2), params.leanF_p_h + (params.p_r_s === 1 && 0.15));
        sideWallCutModel.lineTo(-params.leanF_p_d / 2 + Number(params.add_storage_front) + lengthOffset + offset + wallPosOffset, params.leanF_p_h + (params.p_r_s === 1 && 0.15));
        sideWallCutModel.lineTo(-params.leanF_p_d / 2 + Number(params.add_storage_front) + lengthOffset + offset + wallPosOffset, 0);
        sideWallCutModel.lineTo(-(params.leanF_p_d / 2), 0);
        //
        const meshSideWallModelPattern = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthS, isPattern), extrudeSettings(patternDepthS)));
        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(sideWallCutModel, extrudeSettings(1)))
        
        let meshWallModel_TempS = meshSideWallModelPattern.clone();
        meshWallModel_TempS.position.set(verticalHorizontalPosS.x,verticalHorizontalPosS.y,verticalHorizontalPosS.z);
        meshWallModel_TempS.rotation.set(verticalHorizontalRotS.x,verticalHorizontalRotS.y,verticalHorizontalRotS.z);
        meshWallModel_TempS.updateMatrixWorld();
    
    
        let meshWallDelModel_TempS = meshWallDelModel.clone();
        meshWallDelModel_TempS.position.set(0 , 0, params.p_d / 2 + params.leanF_p_w - 0.5);
        meshWallDelModel_TempS.updateMatrixWorld();
    
        const meshWallModel_CSGS = CSG.fromMesh(meshWallModel_TempS);
        const meshWallDelModel_CSGS = CSG.fromMesh(meshWallDelModel_TempS);
    
    
        const wallModel_CSGS = meshWallModel_CSGS.subtract(meshSideDelModel_CSG);
        const meshWallDel_CSGS = wallModel_CSGS.intersect(meshWallDelModel_CSGS);
        const CSGWallModelS = CSG.toMesh(meshWallDel_CSGS,new THREE.Matrix4());
    
        outerModel = CSGWallModelS.geometry
    
        //************************* */ wainscot wall geometry
        const wainscotVerticalHorizontalPosS = {"x": params.leanF_p_d / -2,"y" : 0, "z" : params.p_d / 2 + params.leanF_p_w + wallThickness + 0.16}
        const wainscotVerticalHorizontalRotS = {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
        const meshSideWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternS, isPattern), extrudeSettings(depthPatternS)))

        let meshSideWainscotModel_Temp = meshSideWainscotModel.clone();
        meshSideWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosS.x,wainscotVerticalHorizontalPosS.y,wainscotVerticalHorizontalPosS.z);
        meshSideWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotS.x,wainscotVerticalHorizontalRotS.y,wainscotVerticalHorizontalRotS.z);
        meshSideWainscotModel_Temp.updateMatrixWorld();
    
        const meshSideWainscotModel_CSG = CSG.fromMesh(meshSideWainscotModel_Temp);
    
        const SideWainscotModel_CSG = meshSideWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const SideWainscotModelCSG = SideWainscotModel_CSG.intersect(meshWallDelModel_CSGS);
        const CSGSideWainscotModel = CSG.toMesh(
            SideWainscotModelCSG,
            new THREE.Matrix4()
            )
    
        wainscotModel = CSGSideWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel}

    }, [params.wallTexture,params.p_d, params.p_r_s, params.p_w_c_n, params.frontLeanStoragePosition, offset, params.leanF_p_d, params.leanF_p_h, params.leanF_p_w, params.p_v_w, params.leanF_p_pos, params.add_storage_check_front, params.add_storage_front, params.add_left_front_lean_porch, params.add_right_front_lean_porch, const_var.newDoorsArray,params.p_b_c_b_f_l])

    const handleMouseEvent = (e) => {
        if (controls.isCheckActiveTab === 'doorwindow' && (const_var.focusedSection === "frontlean" && params.activeWall === "F_L_R_S_W")) {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);
    
    return (
        <group name='front_lean_side_wall' {...eventHandlers}>
            {sideWallModelObj?.outerModel &&
                <mesh name="F_L_F_W" geometry={sideWallModelObj?.outerModel} renderOrder={1}>
                    <MaterialOuterWallNew isPattern={isPattern} visibleSection={"frontlean"} />
                </mesh>
            }
            {params.p_w_c_n === true && sideWallModelObj?.wainscotModel &&
                <mesh name="F_L_F_W_wainscot" geometry={sideWallModelObj?.wainscotModel} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"frontlean"} />
                </mesh>
            }
            {sideWallModelObj && sideWallModelObj?.innerModel && 
                <mesh name="side" geometry={sideWallModelObj?.innerModel} position={[0, 0, -wallThickness*2 - 0.01]}>
                    <MaterialInnerWall texture={texture} visibleSection={"frontlean"} />
                </mesh>
            }
        </group>
    )
}

export default WallModel